export default function (self, fields) {
  //TODO: Disable if rostering is not enabled

  const Fields = {
    title: `Roster - Blockout Periods`,
    minimum: 1,
    maximum: 1,
    key: "join_blockout",
    asObject: true,
    type: "group",
    fields: [
      {
        title: ``,
        minimum: 1,
        maximum: 1,
        key: "blockout",
        asObject: true,
        type: "group",
        fields: [
          {
            title: "Total",
            minimum: 1,
            maximum: 1,
            key: "total",
            type: "integer",
            referenceType: "blockout",
          },
        ],
      },
    ],
  };

  fields.push(Fields);
}
